class KannakiCart {
  constructor() {
    this.drawer = document.getElementById('KannakiCartDrawer');
    this.overlay = document.getElementById('KannakiCartOverlay');
    this.wrapper = document.getElementById('KannakiCartDrawerWrapper');

    if (!this.drawer) return;

    window.kannakiCartInstance = this;

    this.bindEvents();
    this.interceptAddToCart();
  }

  bindEvents() {
    // We bind events to the wrapper so that when the drawer DOM is replaced via section rendering,
    // the event listeners are still active (event delegation).
    this.wrapper.addEventListener('click', (e) => {
      // Close Drawer
      if (e.target.closest('#KannakiCartClose') || e.target.closest('#KannakiCartOverlay') || e.target.closest('#KannakiContinueShopping')) {
        e.preventDefault();
        this.closeDrawer();
      }

      // Open Drawer from floating button
      if (e.target.closest('#KannakiFloatingCartBtn')) {
        e.preventDefault();
        this.openDrawer();
      }

      // Quantity Plus
      if (e.target.closest('.kannaki-qty-plus')) {
        e.preventDefault();
        const btn = e.target.closest('.kannaki-qty-plus');
        const line = btn.dataset.line;
        const input = document.querySelector(`.kannaki-qty-input[data-line="${line}"]`);
        this.updateQuantity(line, parseInt(input.value) + 1);
      }

      // Quantity Minus
      if (e.target.closest('.kannaki-qty-minus')) {
        e.preventDefault();
        const btn = e.target.closest('.kannaki-qty-minus');
        const line = btn.dataset.line;
        const input = document.querySelector(`.kannaki-qty-input[data-line="${line}"]`);
        const newQty = parseInt(input.value) - 1;
        this.updateQuantity(line, newQty > 0 ? newQty : 0);
      }

      // Remove Item
      if (e.target.closest('.kannaki-cart-item-remove')) {
        e.preventDefault();
        const btn = e.target.closest('.kannaki-cart-item-remove');
        this.updateQuantity(btn.dataset.line, 0);
      }
    });
  }

  interceptAddToCart() {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      const action = form.getAttribute('action') || '';
      if (action.includes('/cart/add')) {
        e.preventDefault();

        const formData = new FormData(form);

        // Disable submit button state
        const submitBtn = form.querySelector('[type="submit"]') || form.querySelector('.kannaki-atc') || form.querySelector('button');
        let originalText = '';
        if (submitBtn) {
          submitBtn.disabled = true;
          if (!submitBtn.dataset.originalText) {
            submitBtn.dataset.originalText = submitBtn.innerHTML;
          }
          originalText = submitBtn.dataset.originalText;
          submitBtn.innerHTML = 'LOADING...';
          submitBtn.style.opacity = '0.7';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            this.refreshDrawer();
            this.openDrawer();

            if (submitBtn) {
              submitBtn.innerHTML = '✓ ADDED TO CART';
              submitBtn.style.opacity = '1';

              // Store original styles to revert properly if they were inline
              const origBg = submitBtn.style.backgroundColor;
              const origColor = submitBtn.style.color;
              const origBorder = submitBtn.style.borderColor;

              // Success styling
              submitBtn.style.backgroundColor = '#1f4d25';
              submitBtn.style.color = '#ffffff';
              submitBtn.style.borderColor = '#1f4d25';

              setTimeout(() => {
                submitBtn.disabled = false;
                submitBtn.innerHTML = originalText;
                submitBtn.style.backgroundColor = origBg;
                submitBtn.style.color = origColor;
                submitBtn.style.borderColor = origBorder;
              }, 2500);
            }
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
            alert('There was an error adding this item to your cart.');
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.innerHTML = originalText;
              submitBtn.style.opacity = '1';
            }
          });
      }
    });
  }

  updateQuantity(line, quantity) {
    this.wrapper.classList.add('is-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
      .then(response => response.json())
      .then(cart => {
        this.refreshDrawer();
      })
      .catch(error => console.error('Error updating cart:', error));
  }

  refreshDrawer() {
    fetch(window.location.pathname + '?section_id=kannaki-cart-drawer')
      .then(response => response.text())
      .then(html => {
        // Create a temporary DOM element to parse the new HTML
        const template = document.createElement('div');
        template.innerHTML = html;

        const newDrawerContent = template.querySelector('#KannakiCartDrawer').innerHTML;
        this.drawer.innerHTML = newDrawerContent;

        // Update floating button
        const newFloatingBtn = template.querySelector('#KannakiFloatingCartBtn');
        const oldFloatingBtn = this.wrapper.querySelector('#KannakiFloatingCartBtn');

        if (newFloatingBtn && oldFloatingBtn) {
          oldFloatingBtn.outerHTML = newFloatingBtn.outerHTML;
        } else if (newFloatingBtn && !oldFloatingBtn) {
          this.wrapper.insertBefore(newFloatingBtn, this.overlay);
        } else if (!newFloatingBtn && oldFloatingBtn) {
          oldFloatingBtn.remove();
        }

        this.wrapper.classList.remove('is-loading');
      })
      .catch(error => {
        console.error('Error refreshing drawer:', error);
        this.wrapper.classList.remove('is-loading');
      });
  }

  openDrawer() {
    document.body.classList.add('kannaki-drawer-open');
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
  }

  closeDrawer() {
    document.body.classList.remove('kannaki-drawer-open');
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new KannakiCart();
});
